import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { MagnifyingGlass, Buildings, ArrowsLeftRight } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RoleSelection = () => {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();

  const handleRoleSelect = async (role) => {
    try {
      await axios.post(
        `${API_URL}/api/users/me/role`,
        { role },
        
      );
      updateUser({ role });
      
      if (role === 'seller' || role === 'both') {
        navigate('/seller');
      } else {
        navigate('/buyer');
      }
    } catch (error) {
      console.error('Error updating role:', error);
      // Navigate anyway
      if (role === 'seller' || role === 'both') {
        navigate('/seller');
      } else {
        navigate('/buyer');
      }
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-blue-500 rounded-3xl mx-auto flex items-center justify-center mb-6 shadow-xl shadow-blue-500/20">
            <svg className="w-12 h-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-3">
            How would you like to use SpaceBook?
          </h1>
          <p className="text-slate-600 text-lg">
            You can always switch between modes later from your profile
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-8">
          {/* Find a Space */}
          <button
            onClick={() => handleRoleSelect('buyer')}
            className="group p-8 bg-white rounded-2xl border-2 border-slate-200 hover:border-blue-500 transition-all hover:shadow-xl hover:shadow-blue-500/10 text-left"
            data-testid="buyer-role-btn"
          >
            <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors">
              <MagnifyingGlass className="w-8 h-8 text-blue-500" weight="duotone" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2 font-['Outfit']">Find a Space</h3>
            <p className="text-slate-600">
              Search and book parking, hotels, gyms, coworking spaces, and more
            </p>
          </button>

          {/* List a Space */}
          <button
            onClick={() => handleRoleSelect('seller')}
            className="group p-8 bg-white rounded-2xl border-2 border-slate-200 hover:border-blue-500 transition-all hover:shadow-xl hover:shadow-blue-500/10 text-left"
            data-testid="seller-role-btn"
          >
            <div className="w-16 h-16 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-emerald-100 transition-colors">
              <Buildings className="w-8 h-8 text-emerald-500" weight="duotone" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2 font-['Outfit']">List a Space</h3>
            <p className="text-slate-600">
              Rent out your parking, property, or any space to earn money
            </p>
          </button>
        </div>

        {/* Both option */}
        <Button
          onClick={() => handleRoleSelect('both')}
          variant="outline"
          className="w-full h-14 border-2 border-slate-200 hover:border-blue-500 hover:bg-blue-50 rounded-xl font-semibold text-slate-700 hover:text-blue-600 transition-all"
          data-testid="both-role-btn"
        >
          <ArrowsLeftRight className="w-5 h-5 mr-2" weight="bold" />
          I want to do both
        </Button>

        {user && (
          <p className="text-center mt-8 text-slate-500">
            Logged in as <span className="font-medium text-slate-700">{user.email}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default RoleSelection;
